function openMenuPanel() {
    $('.js-menu-panel').removeClass('d-none');
    $('body').css('overflow', 'hidden');
}
function closeMenuPanel() {
    $('.js-menu-panel').addClass('d-none');
    $('body').css('overflow', '');
    $('.header-submenu__link-menu').removeClass('open');
}
function openSubMenuPanel(e) {
    if ($(e.target).next('.header-submenu__link-menu').length) {
        e.preventDefault();
        $(e.target).next('.header-submenu__link-menu').addClass('open');
    }
}
function openSubSubMenuPanel(e) {
    if ($(e.target).next('.header-sub-sub-menu__link-menu').length) {
        e.preventDefault();
        $(e.target).next('.header-sub-sub-menu__link-menu').addClass('open');
    }
}

function closeSubMenuPanel(e) {
    $(e.target).closest('.header-submenu__link-menu').removeClass('open');
}

function closeSubSubMenuPanel(e) {
    $(e.target).closest('.header-sub-sub-menu__link-menu').removeClass('open');
}

export function initMenuPanel() {
    $('body').on('click', '.js-menu-panel-open', openMenuPanel);
    $('body').on('click', '.js-menu-panel-close', closeMenuPanel);
    $('body').on('click', '#set_filter', closeMenuPanel);

    // if (BX.browser.IsMobile()) {
    //     $('body').on('click', '.header-submenu__link', openSubMenuPanel);
    //     $('body').on('click', '.header-submenu__link-menu-item--back button', closeSubMenuPanel);
    // }

    function isAppleDevice() {
        return (
            (navigator.userAgent.toLowerCase().indexOf('ipad') > -1)
            || (navigator.userAgent.toLowerCase().indexOf('iphone') > -1)
            || (navigator.userAgent.toLowerCase().indexOf('ipod') > -1)
        );
    }
    const device = isAppleDevice();


    $(window).on('load resize', (e) => {
        if ($(window).width() <= 799) {
            console.log('load resize');
            // чтобы пункты меню на apple открывались по первому тапу
            if (device) {
                $('.header-submenu__link').hover(
                    function(el){
                        el.preventDefault();
                        let target = el.target;
                        openSubMenuPanel(el);
                    },
                    function(el){
                        el.preventDefault();
                    }
                )
                $('.header-submenu__link-menu-item--back button').hover(
                    function(el){
                        el.preventDefault();
                        closeSubMenuPanel(el);
                    },
                    function(){
                        el.preventDefault();
                    }
                )
                $('.header-submenu__link').on('click', (el)=> {
                    let target = el.target;
                    openSubMenuPanel(el);
                })
                $('.header-submenu__link-menu-item--back button').on('click', (el)=> {
                    closeSubMenuPanel(el);
                })
            }
            else {
                $('body').on('click', '.header-submenu__link', openSubMenuPanel);
                $('body').on('click', '.header-submenu__link-menu-item--back button', closeSubMenuPanel);
                $('body').off('click', '.header-sub-sub-menu__link', openSubSubMenuPanel);
                $('body').off('click', '.header-sub-sub-menu__link-menu-item--back button', closeSubSubMenuPanel);
            }
        } else {
            $('body').off('click', '.header-submenu__link', openSubMenuPanel);
            $('body').off('click', '.header-submenu__link-menu-item--back button', closeSubMenuPanel);
            $('body').off('click', '.header-sub-sub-menu__link', openSubSubMenuPanel);
            $('body').off('click', '.header-sub-sub-menu__link-menu-item--back button', closeSubSubMenuPanel);
        }
    });
}
